import React from 'react';
import { Process } from '../interfaces/Service';

export interface GroupedProcesses {
    realProcesses: Process[];
    methods: Process[];
    apis: Process[];
}

export function groupProcesses(processes: Process[]): GroupedProcesses {
    const realProcesses = processes.filter(p => p.id < 1000);
    const nonReal = processes.filter(p => p.id >= 1000);
    const methods = nonReal
        .filter(p => p.name.startsWith('Func-'))
        .sort((a, b) => a.friendlyName.localeCompare(b.friendlyName));
    const apis = nonReal
        .filter(p => !p.name.startsWith('Func-'))
        .sort((a, b) => a.friendlyName.localeCompare(b.friendlyName));
    return { realProcesses, methods, apis };
}

export function renderGroupedProcessOptions(grouped: GroupedProcesses) {
    return (
        <>
            {grouped.realProcesses.map(p => (
                <option key={p.id} value={p.id}>{p.friendlyName}</option>
            ))}
            {grouped.methods.length > 0 && (
                <optgroup label="Methods">
                    {grouped.methods.map(p => (
                        <option key={p.id} value={p.id}>{p.friendlyName}</option>
                    ))}
                </optgroup>
            )}
            {grouped.apis.length > 0 && (
                <optgroup label="Apis">
                    {grouped.apis.map(p => (
                        <option key={p.id} value={p.id}>{p.friendlyName}</option>
                    ))}
                </optgroup>
            )}
        </>
    );
}
